import { twMerge } from 'tailwind-merge';
import { formatPrice } from '@witmetrics/utils/strings';
import type { Currency } from '@witmetrics/utils';
import { VAT_LABEL, VAT_NOTE } from '@/constants/pricing';
import { isShippingFree } from '@/utils/pricing';
import type { OrderTotals as Totals } from '@/types/pricing';
import { classes } from './utils';

export interface OrderTotalsProps {
  hideSubtotal?: boolean;
  className?: string;
  currency: Currency;
  size?: 'md' | 'lg';
  totals: Totals;
}

export default function OrderTotals({
  hideSubtotal = false,
  className,
  currency,
  size = 'md',
  totals,
}: OrderTotalsProps) {
  return (
    <div className={twMerge(classes.rows, className)}>
      {!hideSubtotal && (
        <div className={classes.row}>
          <span className={classes.rowLabel}>Subtotal</span>
          <span className={classes.rowValue}>
            {formatPrice(totals.subtotal, currency)}
          </span>
        </div>
      )}
      <div className={classes.row}>
        <span className={classes.rowLabel}>Shipping</span>
        {isShippingFree() ? (
          <span className={classes.free}>Free</span>
        ) : (
          <span className={classes.rowValue}>
            {formatPrice(totals.shipping, currency)}
          </span>
        )}
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>{VAT_LABEL}</span>
        <span className={classes.vatNote}>{VAT_NOTE}</span>
      </div>
      <div className={classes.rule} />
      <div className={classes.totalRow}>
        <span className={classes.totalLabel}>Total excl. VAT</span>
        <span
          className={twMerge(
            classes.totalValue,
            size === 'lg' ? classes.totalLg : classes.totalMd
          )}>
          {formatPrice(totals.total, currency)}
        </span>
      </div>
    </div>
  );
}
